import React from 'react';
import { Box } from '@spothero/ui';
import { SearchPageView } from 'utils/search-page-view';
import SearchMapComponent from 'common/search-results-map/search-map';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import { useOnShowDetailsClick } from 'pages/search/hooks/use-on-show-details-click';
import { useSelector } from 'react-redux';
import { useHideSpotDetails } from '../hooks/use-hide-spot-details/use-hide-spot-details';
export const SearchMap = ({ loadSpots }) => {
    const selectedSpotId = useSelector((state) => state.spots.selectedSpotId);
    const { spotsV2: spots, view } = useReduxSearchState();
    const onShowDetailsClick = useOnShowDetailsClick();
    const onSpotDetailsHidden = useHideSpotDetails();
    return (<Box display={view === SearchPageView.MOBILE_LIST ? 'none' : 'block'} data-testid="SearchMap" position="relative" zIndex="layer1" // avoid clipping of the Search Widget elements
     flex="1 1 auto">
            {/* Overlay when details is opened */}
            {selectedSpotId && (<Box height="100%" width="100%" backgroundColor="navy.900" opacity="0.3" position="absolute" display={{ base: 'none', mobileXL: 'block' }} top="0" bottom="0" left="0" right="0" zIndex="1300" // zindex selected by one layer above map
         onClick={onSpotDetailsHidden}/>)}
            <SearchMapComponent 
    // @ts-expect-error Typing on default export of enhance(SearchMap) is incorrect
    spots={spots} loadSpots={loadSpots} onShowDetailsClick={onShowDetailsClick}/>
        </Box>);
};
